module.exports = __webpack_public_path__ + "img/Feature.cfeda1bd.jpg";